import React, { useEffect, useState } from "react";
import VideoPlayer from '../common/VideoPlayer';
import CardNewsGallery from '../common/CardNewsGallery';
import FeaturedVideo from './FeaturedVideo';
import ContentGallery from './ContentGallery';
import { FaGraduationCap } from 'react-icons/fa';
import './GuideLife_01.scss';


const GuideAcademics_01 = ({ 
  sectionTitle = "학업 안내",
  sectionIcon = <FaGraduationCap />,
  kickerText = "학업안내 추천 콘텐츠",
  subText = "수강신청, 연구활동, 프로그램 등 학업에 관한 모든 정보를 쉽게 확인해보세요.",
  contents = []
}) => {

// 기본 콘텐츠 데이터
const defaultContents = [
    // 학사안내
    {
        id: "acad-yt-1",
        type: "youtube",
        topic: "academic",
        title: "수강신청",
        url: "https://youtu.be/jJAAmwglib4",
        thumb: "https://img.youtube.com/vi/jJAAmwglib4/hqdefault.jpg",
        desc: "[GGUN 제작] 수강신청의 모든 것! 새내기 필수시청!",
        featured: true,
    },
    {
        id: "acad-cn-1",
        type: "cardnews",
        topic: "academic",
        title: "수강신청",
        thumb: "/images/academic1/001.png",
        desc: "어서와, 수강신청은 처음이지?(시간표)",
        images: [ "/images/academic1/001.png", "/images/academic1/002.png", "/images/academic1/003.png", "/images/academic1/004.png",
                  "/images/academic1/005.png", "/images/academic1/006.png", "/images/academic1/007.png", "/images/academic1/008.png"],
    },
    {
        id: "acad-cn-2",
        type: "cardnews",
        topic: "academic",
        title: "수강신청",
        thumb: "/images/academic1/009.png",
        desc: "어서와, 수강신청은 처음이지?(애드메일)",
        images: ["/images/academic1/009.png", "/images/academic1/010.png", "/images/academic1/011.png", "/images/academic1/012.png",
                  "/images/academic1/013.png", "/images/academic1/014.png", "/images/academic1/015.png"],
    },
    {
        id: "acad-cn-3",
        type: "cardnews",
        topic: "academic",
        title: "공부 방법",
        thumb: "/images/academic1/016.png",
        desc: "교수님, 시험공부 어떻게 해야 하나요?",
        images: ["/images/academic1/016.png", "/images/academic1/017.png", "/images/academic1/018.png", "/images/academic1/019.png",
                "/images/academic1/020.png", "/images/academic1/021.png", "/images/academic1/022.png", "/images/academic1/023.png",
                "/images/academic1/024.png", "/images/academic1/025.png"],
    },
    // 연구활동
    {
        id: "res-yt-1",
        type: "youtube",
        topic: "academic",
        title: "GIST 연구실 인턴",
        url: "https://youtu.be/OOIoq2ZPLBo",
        thumb: "https://img.youtube.com/vi/OOIoq2ZPLBo/maxresdefault.jpg",
        desc: "GIST 연구실 인턴 V-LOG",
    },
    {
        id: "res-cn-1",
        type: "cardnews",
        topic: "academic",
        title: "연구실 인턴",
        thumb: "/images/research/001.png",
        desc: "나도 할 수 있다, 연구실 인턴!",
        images: ["/images/research/001.png", "/images/research/002.png", "/images/research/003.png", "/images/research/004.png",
                "/images/research/005.png", "/images/research/006.png", "/images/research/007.png", "/images/research/008.png",
                "/images/research/009.png"],
    },
    {
        id: "res-cn-2",
        type: "cardnews",
        topic: "academic",
        title: "연구실 인턴",
        thumb: "/images/research/010.png",
        desc: "방학에 놀면 뭐하니? (G-SURF 파헤치기!)",
        images: ["/images/research/010.png", "/images/research/011.png", "/images/research/012.png", "/images/research/013.png",
                "/images/research/014.png", "/images/research/015.png", "/images/research/016.png"],
    },
    // 프로그램
    {
        id: "prog-yt-1",
        type: "youtube",
        topic: "academic",
        title: "무한도전 프로젝트",
        url: "https://youtu.be/GYXlu9XjMFY",
        thumb: "https://img.youtube.com/vi/GYXlu9XjMFY/hqdefault.jpg",
        desc:"'실패해도 좋아, 한 번 도전해 보는 거야!'",
    },
    {
        id: "prog-cn-1",
        type: "cardnews",
        topic: "academic",
        title: "무한도전 프로젝트",
        thumb: "/images/program1/01.PNG",
        desc: "지온나래가 알려주는 무한도전",
        images: ["/images/program1/01.PNG", "/images/program1/02.PNG", "/images/program1/03.PNG","/images/program1/04.PNG", "/images/program1/05.PNG", "/images/program1/06.PNG"],
    },
    {
        id: "prog-cn-2",
        type: "cardnews",
        topic: "academic",
        title: "교환학생 프로그램",
        thumb: "/images/program1/1.png",
        desc: "지온나래가 소개하는 교환학생 프로그램",
        images: ["/images/program1/1.png", "/images/program1/2.png", "/images/program1/3.png", "/images/program1/4.png",
                "/images/program1/5.png", "/images/program1/6.png", "/images/program1/7.png"],
    },
    {
        id: "prog-cn-3",
        type: "cardnews",
        topic: "academic",
        title: "교환학생 프로그램",
        thumb: "/images/program2/01.PNG",
        desc: "해외 계절학기 프로그램 UC Berkeley",
        images: ["/images/program2/01.PNG", "/images/program2/02.PNG", "/images/program2/03.PNG", "/images/program2/04.PNG",
                "/images/program2/05.PNG", "/images/program2/06.PNG", "/images/program2/07.PNG", "/images/program2/08.PNG"],
    },
];

// props로 받은 contents가 있으면 사용, 없으면 기본 데이터 사용
const displayContents = contents.length > 0 ? contents : defaultContents;

// ✅ 모달
const [selected, setSelected] = useState(null);

const openContent = (c) => {
    setSelected(c);
};

const closeModal = () => {
    setSelected(null);
};

// ESC 키로 모달 닫기
useEffect(() => {
    const onKeyDown = (e) => {
    if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
}, []);

// featured content 찾기
const featuredContent = displayContents.find((c) => c.topic === "academic" && c.featured && c.type === "youtube") ||
    displayContents.find((c) => c.topic === "academic" && c.type === "youtube") ||
    null;

return (
  <>

    


    <div className="GuideLife_container">

      {/* Hero 섹션 */}
      <section className="sec-guide-hero">
        <div className="GuideHero">
          <div className="box-main">
            <h1 className="guide-title">GISTian 학업</h1>
            <p className="guide-desc">
              지온나래·꾼·GIST 콘텐츠와 함께 학업 정보를 한눈에 살펴보세요.
            </p>
          </div>
        </div>
      </section>

      <br /><br /><br />

      <div className="hub-container">
        <h3 className="section-title">
          <span className="section-icon">{sectionIcon}</span>
          {sectionTitle}
        </h3>

        <div className="hub">
          <FeaturedVideo 
            kicker={kickerText}
            sub={subText}
            featured={featuredContent}
            onOpenContent={openContent}
          />
          
          <ContentGallery 
            contents={displayContents.filter((c) => c.topic === "academic")}
            onOpenContent={openContent}
          />
        </div>
      </div>

      {/* ✅ Modal */}
      {selected && selected.type === "youtube" && (
        <VideoPlayer
          url={selected.url}
          title={selected.title}
          onClose={closeModal}
        />
      )}
      
      {selected && selected.type === "cardnews" && (
        <CardNewsGallery
          images={selected.images}
          title={selected.title}
          onClose={closeModal}
        />
      )}
    </div>
  
    </>
  );
};

export default GuideAcademics_01;